import Home from '@/pages/[locale]'
import { makeStaticProps } from '@/utils/getStatic'
export default Home
const getStaticProps = makeStaticProps(['common', 'articles-listing', 'modals'])

export { getStaticProps }
